<template>
	<div v-if="isVisible" class="popup-container">
		<div class="card white popup">
			<h2>{{ title }}</h2>
			<div class="form-control">
				<label for="name">Nom</label>
				<input type="text" id="name" :value="partage.name" disabled />
			</div>
			<div class="form-group">
				<div class="form-control">
					<label for="expiration">Expiration</label>
					<input type="text" id="expiration" :value="partage.expiration" disabled />
				</div>
				<div class="form-control">
					<label for="reference">Protégé</label>
					<input type="text" id="reference" :value="partage.password ? 'Oui' : 'Non'" disabled />
				</div>
			</div>

			<div class="form-control">
				<p>Fichiers:</p>
				<div v-for="file in partage.files.filter(file => file !== null)" :key="file.ID" class="file-entry">
					<i class="bi bi-file-pdf-fill"></i>
					<p class="file-name">{{ file.name }}</p>
					<i class="file-icon bi bi-download" @click="downloadFile(file.fileID)"></i>
					<i class="file-icon bi bi-eye-fill" @click="viewFile(file.fileID)"></i>
				</div>
			</div>

			<p v-if="errorMessage">{{ errorMessage }}</p>
			<div class="popup-actions">
				<!-- <button class="button fill orange" @click="confirmAction">{{ confirmButtonText }}</button> -->
				<button class="button outline orange" @click="cancelAction">{{ cancelButtonText }}</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		isVisible: Boolean,
		title: String,
		partage: {},
		confirmButtonText: {
			type: String,
			default: "Mettre à jour",
		},
		cancelButtonText: {
			type: String,
			default: "Annuler",
		},
	},
	data() {
		return {
			errorMessage: "",
		};
	},
	methods: {
		viewFile(fileId) {
			const url = process.env.VUE_APP_API_URL + "read/" + fileId;
			window.open(url, "_blank");
		},
		downloadFile(fileId) {
			const url = process.env.VUE_APP_API_URL + "download/" + fileId;
			window.open(url, "_blank");
		},
		async confirmAction() {
			this.$emit("confirm");
		},
		cancelAction() {
			this.errorMessage = "";
			this.$emit("cancel1");
		},
	},
};
</script>